import BannerUsuario from "../../images/Banner_usuario.jpg";
import BannerDirectorioProfesional from "../../images/DirectorioProfesional.png";
import BannerTeleconsultas from "../../images/ReviveBanner.png";
import BannerBeneficios from "../../images/Beneficios.png";
import Background2 from "../../images/background2.png";
import BannerEscritorio from "../../images/BannerEscritorio-8.png";
import { ReactComponent as FlechaIngresar } from "../../assets/icons/ingresar.svg";
import { ReactComponent as Teleconsulta } from "../../assets/icons/citas.svg";
import { ReactComponent as Directorio } from "../../assets/icons/contacto.svg";
import { ReactComponent as Beneficio } from "../../assets/icons/beneficios.svg";
import SvgIcon from "../../utils/Icon";
import { useNavigate, useLocation } from "react-router-dom";
import { useDataUser } from "../../context/dataUserContext";
import { useState, useEffect } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import apiClient from "../../utils/axiosPetition";

const Dashboard = () => {
    //Dejar solo imagenes 0 texto
    const navigate = useNavigate();
    const location = useLocation();
    const { role, patientId } = useDataUser();
    const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
    const [patientProfileIncomplete, setPatientProfileIncomplete] = useState(false);
    
    // Determinar si es doctor basado en la ruta o el rol
    // Si la ruta contiene '/doctor', entonces es un doctor
    const isDoctorRoute = location.pathname.includes('/doctor');
    const isDoctor = role === 'doctor' || isDoctorRoute;
    const isPatientDashboard = role === 'patient' && location.pathname.includes('/patient');

    useEffect(() => {
        if (!isPatientDashboard || !patientId) {
            setPatientProfileIncomplete(false);
            return;
        }
        apiClient.get(`/api/patient/${patientId}`)
            .then((res) => setPatientProfileIncomplete(res.data?.profileComplete !== true))
            .catch(() => setPatientProfileIncomplete(localStorage.getItem('patientProfileComplete') !== 'true'));
    }, [isPatientDashboard, patientId]);
    
    // Determinar la ruta correcta según el rol del usuario
    // Si no está logueado, usar la ruta pública para evitar redirección a login y vuelta al dashboard
    const getDirectorioRoute = () => {
        if (isDoctor) {
            return '../directorio-profesionales';
        }
        if (role === 'patient') {
            return '../directorio-profesionales';
        }
        // Usuario no autenticado: directorio público (evita loop dashboard → /patient/... → redirect → dashboard)
        return '/directorio-profesionales';
    };

    // Banners para el carousel (solo para doctores)
    const bannerSlides = [
        {
            text: "¿Conoces cómo crear tu perfil profesional? Nosotros te asesoramos escríbenos a Info@redplika.co",
            image: BannerEscritorio
        }
    ];

    const nextBanner = () => {
        setCurrentBannerIndex((prev) => (prev + 1) % bannerSlides.length);
    };

    const prevBanner = () => {
        setCurrentBannerIndex((prev) => (prev - 1 + bannerSlides.length) % bannerSlides.length);
    };

    const services = [
        {
            title: "Teleconsultas",
            icon: Teleconsulta,
            image: BannerTeleconsultas,
            description: "Programa tu próxima cita a través de nuestra app de consultas"
                + " virtuales.Eliges el prestador que necesitas, gestionas la cita y listo... así de fácil.",
            buttonText: "Programar",
            navigate: "../teleconsultas"
        },
        {
            title: "Directorio Profesional",
            icon: Directorio,
            image: BannerDirectorioProfesional,
            description: "Al ser parte de Redplika tienes acceso al completo directorio de"
                + " profesionales y prestadores de salud, miembros de la red.",
            buttonText: "Acceder",
            navigate: "../directorio-profesionales"
        },
        {
            title: "Beneficios para ti",
            icon: Beneficio,
            image: BannerBeneficios,
            description: "Por ser parte de REDPLIKA, accede a condiciones especiales, descuentos, tarifas preferenciales y otras oportunidades ofrecidas por nuestra red de aliados.",
            buttonText: "Explora los aliados disponibles y descubre los beneficios que tenemos para ti →",
            navigate: "../aliados"
        }
    ]

    return (
        <div className="w-full space-y-8 md:space-y-12 px-2 md:px-0">
            {patientProfileIncomplete && (
                <div className="rounded-2xl border-l-4 border-amber-400 bg-gradient-to-r from-amber-50 to-orange-50 p-5 shadow-sm">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                        <div className="flex-1">
                            <h3 className="text-lg font-semibold text-amber-900 mb-1">
                                Tu perfil está incompleto
                            </h3>
                            <p className="text-sm text-amber-800">
                                Completa tus datos en <strong>Perfil</strong> para agendar teleconsultas y usar todos los servicios de Redplika.
                            </p>
                        </div>
                        <button
                            type="button"
                            onClick={() => navigate('../perfil')}
                            className="shrink-0 px-5 py-2.5 bg-[#1f94c2] hover:bg-[#1a7ba8] text-white font-semibold rounded-xl transition-colors"
                        >
                            Completar mi perfil
                        </button>
                    </div>
                </div>
            )}

            {/* Banner */}
            {isDoctor ? (
                // Banner original con texto y flechas (solo para doctores)
                <div className="relative overflow-hidden rounded-3xl shadow-xl">
                    <div 
                        className="relative group"
                    >
                        {/* Imagen de fondo */}
                        <img
                            src={bannerSlides[currentBannerIndex].image}
                            alt="Banner"
                            className="w-full h-[16em] md:h-[50vh] object-contain md:object-cover md:object-[50%_40%] transition-transform duration-700 ease-in-out group-hover:scale-110"
                        />
                        {/* Texto del banner - izquierda con colores azul, naranja y negro */}
                        <div className="absolute left-6 md:left-8 top-1/2 -translate-y-1/2 p-4 md:p-6">
                            <p className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight max-w-2xl mb-3">
                                <span className="text-[#1f94c2ff]">¿Conoces </span>
                                <span className="text-[#f79865ff]">cómo crear tu perfil profesional ?</span>
                            </p>
                            <p className="text-lg md:text-xl lg:text-2xl font-extrabold leading-relaxed max-w-2xl">
                                <span className="text-gray-900 font-black">Nosotros te asesoramos escríbenos a </span>
                                <span className="text-[#1f94c2ff]">Info@redplika.co</span>
                            </p>
                        </div>
                    </div>
                    
                    {/* Flechas de navegación */}
                    {bannerSlides.length > 1 && (
                        <>
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    prevBanner();
                                }}
                                className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-[#1f94c2ff] p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-10"
                                aria-label="Banner anterior"
                            >
                                <FaChevronLeft className="w-5 h-5" />
                            </button>
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    nextBanner();
                                }}
                                className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-[#1f94c2ff] p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-10"
                                aria-label="Banner siguiente"
                            >
                                <FaChevronRight className="w-5 h-5" />
                            </button>
                        </>
                    )}
                </div>
            ) : (
                // Banner nuevo sin texto (para pacientes): se muestra completo sin recortes
                <div 
                    className="relative overflow-hidden rounded-3xl cursor-pointer group shadow-xl hover:shadow-2xl transition-all duration-500 ease-in-out transform hover:scale-[1.02] bg-[#0ea5e9]/10"
                    onClick={() => navigate(getDirectorioRoute())}
                >
                    {/* Imagen: object-contain y proporción natural para no recortar logo, texto ni CTA */}
                    <img
                        src={BannerUsuario}
                        alt="Encuentra el especialista y la modalidad que necesitas"
                        className="w-full h-auto max-h-[40vh] md:max-h-[55vh] object-contain object-center transition-transform duration-700 ease-in-out group-hover:scale-[1.03] block"
                    />
                    {/* Overlay con gradiente */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-all duration-500 ease-in-out pointer-events-none"></div>
                    {/* Borde sutil */}
                    <div className="absolute inset-0 border-4 border-white/30 rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"></div>
                </div>
            )}

            {/* Servicios */}
            <section className="flex justify-center w-full">
                <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
                    {services && services.map((service, index) => (
                        <CardServices
                            key={index}
                            title={service.title}
                            icon={service.icon}
                            image={service.image}
                            description={service.description}
                            buttonText={service.buttonText}
                            linkRedireccion={service.navigate}
                            index={index}
                        />
                    ))}
                </div>
            </section>
        </div>
    );
};

export default Dashboard;

const CardServices = ({ title, icon, image, description, buttonText, linkRedireccion, index }) => {
    const navigate = useNavigate();
    return (
        <div 
            className="group bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 ease-in-out transform hover:-translate-y-2 overflow-hidden animate-slide-up"
            style={{ animationDelay: `${index * 0.1}s` }}
        >
            {/* Header con gradiente */}
            <div className="bg-gradient-to-r from-[#f79865ff] to-[#ffa16f] flex items-center px-4 py-2.5 text-white font-bold rounded-t-3xl shadow-md">
                <div className="bg-white/20 p-1.5 rounded-lg mr-2.5 backdrop-blur-sm">
                    <SvgIcon Icon={icon} className={"w-5 h-5 text-white"} />
                </div>
                <span className="text-base">{title}</span>
            </div>
            
            {/* Contenido de la card */}
            <div className="relative w-full min-h-[240px] md:min-h-[280px] overflow-hidden rounded-b-3xl">
                {/* Imagen de fondo */}
                <img 
                    src={image} 
                    alt={title} 
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-110" 
                />
                
                {/* Overlay con gradiente */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
                
                {/* Contenido sobre la imagen */}
                <div className="absolute inset-0 flex flex-col justify-between p-5">
                    <p className="text-white text-sm md:text-base leading-relaxed font-medium drop-shadow-lg">
                        {description}
                    </p>
                    
                    {/* Botón moderno */}
                    <button
                        className="self-end max-w-full bg-gradient-to-r from-[#1f94c2ff] to-[#1a7fa8] hover:from-[#1a7fa8] hover:to-[#1f94c2ff] text-white text-left text-xs sm:text-sm font-semibold px-4 py-2 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-1.5 group/btn"
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate(linkRedireccion);
                        }}
                    >
                        <span>{buttonText}</span>
                        {!String(buttonText).includes('→') && (
                            <SvgIcon Icon={FlechaIngresar} className="w-4 h-4 shrink-0 transform group-hover/btn:translate-x-1 transition-transform" />
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
}